@import 'src/styles/common/_colors.scss';

.navone {
	height: 34px;
	z-index: 3;
	/* fix bottom shadow visibility */
}

.navone {
	padding: 0 3px 0 0;
	// background: linear-gradient(to bottom,  #3d3e41 0%,#222222 49%,#1b1b1b 51%,#020606 100%);
	background: $black;
	box-shadow: 0 1px 1px $white-variant-2;
	z-index: 601;
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	position: sticky;
	top: 0;
}

.headerCenter {
	display: flex;
	align-items: center;
}

.navone .dropdown-toggle {
	line-height: 20px;
}

.accountWrapper {
	width: 45%;
	display: flex;
	justify-content: flex-end;
}


.logo,
.topIcon {
	color: $light-gray-variant-1;
	text-shadow: 0 2px 1px $text-shadow-color;
}

.logo {
	padding: 3px 0 3px 21px;
	display: inline-flex;
	vertical-align: top;

	.logoIcon {
		font-size: 22px;
		margin-right: 9px;
	}

	.logoText {
		font-family: 'Oswald', sans-serif;
		font-size: 12px;
		line-height: 15px;
		color: $lightgray;
		padding-left: 8px;
		padding-top: 2px;
		padding-bottom: 2px;
		border-left: solid $gray-variant-9 1px;
		margin-top: 2px;
		margin-bottom: 2px;
	}
}

.logo a {
	color: $light-gray-variant-2;
	text-decoration: none;
}

.breadcrumbsWrapper {
	width: 45%;
	white-space: nowrap;

	.breadcrumbLevel {
		min-width: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		label {
			padding-left: 25px;
			color: $button-icon-color;
			font-weight: 600;
			text-decoration: underline;
			cursor: pointer;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 240px;
			width: auto;

			&:hover {
				color: $green-variant-1;
			}
		}

		.home {
			top: -12px;
		}
	}
}

.homeBreadcrumb {
	height: 100%;
	display: inline-block;
	vertical-align: top;
}

.home {
	font-size: 12px;
	margin-left: 15px;
	position: relative;
	top: 6px;
	color: $light-gray-variant-2;
}

.breadcrumbLevel .home {
	margin-left: -10px;
}

.home a:hover {
	color: $green-variant-1;
	cursor: pointer;
}

.breadcrumb {
	display: inline-block;
	height: 33px;
	margin-left: 5px;
	position: relative;
}

.breadcrumb div {
	display: inline-block;
}

.breadcrumb a {
	text-decoration: underline;
	display: inline-block;
	overflow: hidden;
	text-overflow: ellipsis;
}

.breadcrumb a:hover {
	cursor: pointer;
	color: $green-variant-1;
}

.breadcrumb a,
.breadcrumb span {
	outline: none;
	font-size: 12px;
	line-height: 36px;
	color: $light-gray-variant-2;
	padding: 0 15px 0 10px;
	position: relative;
	margin-left: 10px;
	font-weight: 600;
}

.breadcrumb span {
	color: $green-variant-1;
}

.home::after,
.breadcrumb::after {
	content: '';
	position: absolute;
	width: 24px;
	height: 24px;
	left: 5px;
	transform: scale(0.76) rotate(45deg) skew(20deg, 20deg);
	z-index: 1;
	background: transparent;
	box-shadow: 2px -2px 0 0px $button-green-disabled-icon-color;
}

.breadcrumb::after {
	left: initial;
	top: 5px;
	right: -8px;
}

.hideShowLegendItem {
	float: right;
	padding: 10px;
	text-decoration: underline;
	cursor: pointer;
}

.hideShowLegendItem.disabled a:hover,
.hide-SowLegendtem.disabled {
	color: $button-green-disabled-icon-color;
	cursor: default;
}

.topIcon {
	float: left;
	padding: 5px 0 5px 24px;
	font-size: 18px;
	cursor: pointer;
}

.topIcon .name {
	font-size: 12px;
	color: $white;
}

.pageTitle {
	line-height: 30px;
	font-family: 'Oswald', sans-serif;
	font-size: 16px;
	text-shadow: 0 1px 1px $text-shadow-color;
	color: $white;
	letter-spacing: .05em;
	padding-left: 20px;
	white-space: nowrap;
	flex-shrink: 0;
}

.copyrightVersionWelcome {
	display: block;
	font-size: 10px;
	font-family: "Open Sans";
	color: $gray-variant-10;
	font-style: italic;
	padding: 0 10px 0 0;
	text-align: right;
}

.informationText {
	font-size: 10px;
	font-family: "Open Sans";
	color: $gray-variant-10;
	font-style: italic;
	padding: 0 10px 0 0;
}

.profileDropdownBtn {
	background: transparent !important;
	color: $smoke-white;

	&:hover {
		color: $tile-white ;
	}
}

@media (max-width: 1200px) {
	.breadcrumbsWrapper .breadcrumbLevel label {
		max-width: 180px;
	}

	.pageTitle {
		padding-left: 10px;
	}
}

@media (max-width: 1100px) {
	.breadcrumbsWrapper .breadcrumbLevel label {
		max-width: 150px;
	}

	.pageTitle {
		padding-left: 30px;
	}
}

@media (max-width: 950px) {
	.breadcrumbsWrapper .breadcrumbLevel label {
		max-width: 120px;
	}

	.pageTitle {
		padding-left: 50px;
	}
}